export type CryptoTradingOrderInfoType ={
  userId: string,
  paymentType: string,
  amount: string,
  passageType: string,
  receivingAddress: string,
  copeAmount: number,
  createDate: string,
  status: string,
  createTime: string,
  updateTime: string,
  orderId: number,
  orderNo: string,
}

export type CryptoAccountInfoType ={
  address: string,
  otcTicker: string
}

export type CryptoTradingOrderType = "TronDeposit" | "DepositTransferIn" |"TronTransferBusiness" | 'DepositTransferOut' | 'ChangeUsdt' ;

export type CryptoTradingStateType = {
  orderType: CryptoTradingOrderType,
  loading: boolean,
  countdown: number,
  orderInfo: CryptoTradingOrderInfoType,
  cryptoAccountInfo: CryptoAccountInfoType,
  timer: ReturnType<typeof setTimeout> | null;
  form: {
    amount: number,
    paymentType: string, 
  }
}



export const initialState: CryptoTradingStateType = {
    orderType: 'TronDeposit',
    loading: true,
    countdown: 0,
    orderInfo: {
      userId: '',
      paymentType: "",
      amount: "",
      passageType: "",
      receivingAddress: "",
      copeAmount: 0,
      createDate: "",
      status: "",
      createTime: "",
      updateTime: "",
      orderId: 0,
      orderNo: "",
    },
    cryptoAccountInfo:{
      address: "",
      otcTicker: ""
    },
    form: {
      amount: 0,
      paymentType: '', 
    },
    timer: null, 
}